import { forwardRef, memo, useCallback, useEffect, useMemo, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import {
  BzButton,
  BzDropdown,
  BzToolTip,
} from "../../../components";
import { BEST5_INDEX, LOCATIONS, LOCAL_STORAGE_KEYS, ORDER_ENTRY_BUTTON_TOGGLE, SIDE_TRAY_EXPAND_PERCENTAGE, TL_INDEX, WATCHLIST_GRID_INDEX, GRID_VIEW, CHART_OPEN_MODE } from "../../../utils/global_variables";
import ChartWidget from "../ChartWidget";
import { isUserIsAGuest, ORDER_ENTRY_GRID_REF, WATCHLIST_GRID_REF, createChartUrl, getApiExchangeNameFromMktSegId, getMappedMktSegIdFromApiExchangeName, getDecryptLocalStorage, setEncryptLocalStorage, openOrderEntryModal } from "../../../utils/global_functions";
import { getMarketMovementFailure, getMarketMovementInfo, getSecurityDetails, setScripOverviewData, updateSideExapnsion, updateSideOverViewWatchlistSynced } from "../../../redux/actions/marketOverview";
import { useDispatch, useSelector } from "react-redux";
import { sendDataToChart } from "../../../utils/global_functions";
import { useWFHMessages } from "../../../hooks";
import { getScripOrderInfo, getSpreadOrder, updateIsBuyOrSell } from "../../../redux/actions/orders";
import { handleModal, handleModalData } from "../../../redux/actions/modals";
import { sendTouchlineRequest } from "../../../apis/web_socket";
import { toastConfig } from "../../../redux/actions/toast";
import { getFocusedCard } from "../../../redux/actions/watchlist";
import { getWfhTouchlineLastTick } from "../../../redux/actions/wfh";
import SideChartScripInfo from "./SideChartScripInfo";
import CandleChart from "../../Analysis/CandleChart";
import LineChart from "../../Analysis/LineChart";
import BarChart from "../../Analysis/BarChart";
import AreaChart from "../../Analysis/AreaChart";
import { getHistoricChartData } from "../../../apis/nontransactional";
import { convertHistoricData } from "../../../controllers/analysis";
import moment from "moment";
import ZeroStates from "../../ZeroStates";

const mappedTime = {
  '1D': 'Intraday',
  '5D': 5,
  '1M': 30,
  '1Y': 260,
  '2Y': 520,
  '5Y': 1300,
  'MAX': 0,
};
const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
  <div
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className={className}
  >
    {children}
  </div>
));

const SideChart = ({
  isExpanded,
  setIsExpanded,
  setToggleSideContainer,
  setActiveMenu,//BT- 112339 : Watchlist || Side Tray || Closing functionality : ManasaB : 30/06/2023
  chartUrl,
  scripOnExpand,
  isVertical = true,
  setChartExpand,
  chartExpand,
  sideTraySync,
  halfHeight = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const [bToggleSearchBar, setBToggleSearchBar] = useState(false);
  //Vaibhav Singh: 107400: Buy/Sell Price not showing earlier fixed: 16-11-23: Start
  const [arrScripInformation, setArrScripInformation] = useState([]);
  //Vaibhav Singh: 107400: Buy/Sell Price not showing earlier fixed: 16-11-23: End
  const chartAttributes = useSelector(state => state.appInfo.chartAttributes);
  const [toggledURL, setToggledURL] = useState('');
  const [chartURL, setchartURL] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);
  const [syncWatchlist, setSyncWatchlist] = useState(false);
  const [savePrevData, setSavePrevData] = useState({ prevRow: [], prevChart: '' });
  const [timeInterval, setTimeInterval] = useState('1D');
  const [lineData, setLineData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [chartType, setChartType] = useState('Candles');
  const [maType, setMaType] = useState(20);
  const [chartTab, setChartTab] = useState('Intraday');
  const [apiCalled, setApiCalled] = useState(false);
  const [zeroStateShow, setZeroStateShow] = useState(false);
  const marketMovementInfo = useSelector(state => state.marketOverview.marketMovementInfo);
  const scripOverviewData = useSelector(state => state?.marketOverview?.scripOverviewData);
  // Deepti b. BT-107398 [18/11/2024]: selected heatmap tile data
  const selectedHeatmapTile = useSelector(state => state?.watchList?.selectedHeatmapTile);
  const watchlistView = useState(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.WATCHLIST_VIEW));

  // Vaibhav Singh: 112339: 30-08-2023: Changed WATCHLIST_GRID_REF to OrderscripInfo
  const objScripOrderInfo = useSelector(state => state.orders.scripOrderInfo);
  const { scripOrderInfo = [] } = useMemo(() => ({ scripOrderInfo: objScripOrderInfo?.scripData, activeButtonToggleIndex: objScripOrderInfo?.isBuySell, activeMktSegId: objScripOrderInfo?.activeExchangeId }), [objScripOrderInfo]);
  const [tempScripOrderInfo, setTempScripOrderInfo] = useState(scripOrderInfo);
  //Vaibhav Singh: 107400: Buy/Sell Price not showing earlier fixed: 16-11-23: Start
  const handleArrGridRowData = (segmentId, token, e) => {
    const detail = [...e.detail];
    if (segmentId === detail[BEST5_INDEX.SEGMENT_ID] && token === detail[BEST5_INDEX.TOKEN]) {
      //By HiralK : 06-09-2023 : For Price optimization - Start
      detail[BEST5_INDEX.LAST_TRADE_PRICE] = (detail[BEST5_INDEX.LAST_TRADE_PRICE]);//.toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
      //detail[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = detail[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] / scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
      //By HiralK : 06-09-2023 : For Price optimization - End
      setArrScripInformation(detail);
    }
  };
  useWFHMessages('bestfive', (e) => {
    handleArrGridRowData(selectedRow[WATCHLIST_GRID_INDEX.SEGMENT_ID], selectedRow[WATCHLIST_GRID_INDEX.TOKEN], e);
  });
  useEffect(() => {
    if (!isVertical) {
      setSyncWatchlist(sideTraySync);
    }
  }, [sideTraySync]);
  useEffect(() => {
    if (scripOverviewData?.length && !isVertical) {
      setchartURL(createChartUrl(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
      setSelectedRow(scripOverviewData);
    }
  }, [scripOverviewData]);
  //Vaibhav Singh: 14-03-24: Issue fixed with CHart toggle: Start
  useEffect(() => {
    if (chartAttributes?.nMultiChartPresent) {
      const chartId = JSON?.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.PREFFERED_CHART));
      if (chartId) {
        setToggledURL(chartId?.name);
      }
    }
  }, [chartAttributes]);
  useWFHMessages('bestfive', (e) => {
    if (tempScripOrderInfo?.length) {
      if (e.detail[TL_INDEX.TOKEN] === tempScripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN]) {
        sendDataToChart(e.detail, tempScripOrderInfo);
      }
    }
  });
  useEffect(() => {
    if (selectedRow?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
      const objLastTickData = dispatch(getWfhTouchlineLastTick());
      const arrLastTickScripData = objLastTickData[selectedRow[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
      if (arrLastTickScripData?.length > 0) {
        arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE] = (parseFloat(arrLastTickScripData[BEST5_INDEX.LAST_TRADE_PRICE]));
        arrLastTickScripData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = (arrLastTickScripData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]); // Hari: 29-07-2023 show LTP change in recommendations scrip overview
        setArrScripInformation([...arrLastTickScripData]);
      } else { }
    } else { }
    if (chartAttributes?.nMultiChartPresent) {
      const chartId = JSON?.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.PREFFERED_CHART));
      if (chartId) {
        setToggledURL(chartId?.name);
      }
    }
  }, [dispatch, selectedRow]);
  const setOrderEntryScripPrice = (activeButtonToggleIndex) => {
    const nAskPrice = parseFloat(arrScripInformation[BEST5_INDEX.SELL_PRICE_1]);
    const nLTP = parseFloat(arrScripInformation[BEST5_INDEX.LAST_TRADE_PRICE]);
    const nBidPrice = parseFloat(arrScripInformation[BEST5_INDEX.BUY_PRICE_1]);
    if (activeButtonToggleIndex === ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
      if (nAskPrice > 0) {
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nAskPrice }));
      } else {
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
      }
    } else {
      if (nBidPrice > 0) {
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nBidPrice }));
      } else {
        ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: nLTP }));
      }
    }
  };

  const handleApi = useCallback(async (time) => {
    setLineData([]);
    if (time !== '1D') {
      let temp = await getHistoricChartData({
        MktSegId: tempScripOrderInfo[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
        Token: tempScripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
        Records: mappedTime[time],
      });
      let data = [];
      temp?.data?.result.forEach(x => {
        if (x?.length > 0) {
          data.push(...convertHistoricData(x));
        }
      });
      data = data?.map(x => {
        return {
          time: moment(x?.ltt)?.format("YYYY-MM-DD"),
          value: x?.close,
          open: x?.open,
          high: x?.high,
          low: x?.low,
          close: x?.close,
          volume: x?.volume
        };
      });
      setLineData(data);
      if (!chartURL && data?.length === 0) {
        setZeroStateShow(true);
      } else {
        setZeroStateShow(false);
      }
    }
  }, [chartURL, tempScripOrderInfo]);

  //Vaibhav Singh : BT-117493 : 13-09-2023 : Removed Global Search and header
  //Vaibhav Singh: 08-09-2023 : BUY and SELL functionality added 
  const handlePlaceOrder = useCallback(async (nIsBuyOrSell = 0) => {
    await dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, { 'MARKET_OVERVIEW_MODAL': false }]));
    setTimeout(() => {
      dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: selectedRow[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: selectedRow }));
      setOrderEntryScripPrice(nIsBuyOrSell);
    }, 200);
  }, [selectedRow, dispatch]);
  //Vaibhav Singh: 107400: Buy/Sell Price not showing earlier fixed: 16-11-23: End

  const onBuySellClick = (strBuySell) => {
    setActiveMenu({});
    setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE?.ZERO_PERCENT }; });
    if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
      if (selectedRow[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
        handleSelectSpreadOrderModel(selectedRow, strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry 
      } else {
        handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1);
      }
    } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

  };
  const handleSelectSpreadOrderModel = (spreadArr, strBuySell) => {
    dispatch(updateIsBuyOrSell(strBuySell));//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
    var spreadPaylod =
    {
      "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API
      "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
      "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
    };
    sendTouchlineRequest([
      { exchangeId: spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: spreadArr[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true },

    ]);

    dispatch(getSpreadOrder(spreadPaylod));
    dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
    dispatch(handleModalData({ data: { spreadArr: spreadArr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
  };

  // Vaibhav Singh: 112339: 29-08-2023: Changes for displaying Initial Chart and active element visible
  // Deepti B.[26/11/2024]: BT-107398 : selecting first scrip for displaying initial chart for heatmap view
  useEffect(() => {
    if (watchlistView?.[0] === GRID_VIEW.HEAT_MAP) {
      setchartURL(createChartUrl(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID], selectedHeatmapTile[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
      setSelectedRow(selectedHeatmapTile);
      dispatch(getFocusedCard(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
    } else if (watchlistView?.[0] === GRID_VIEW.DEFAULT_VIEW) {
      if (WATCHLIST_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0)?.data) {
        if (WATCHLIST_GRID_REF?.current?.api?.getSelectedRows()[0]?.length) {
          setSelectedRow(WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0]);
          setchartURL(createChartUrl(WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], WATCHLIST_GRID_REF?.current?.api?.getSelectedRows()[0][WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
          dispatch(getFocusedCard(WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
        } else {
          setSelectedRow(WATCHLIST_GRID_REF?.current?.api.getDisplayedRowAtIndex(0)?.data);
          setchartURL(createChartUrl(WATCHLIST_GRID_REF?.current?.api.getDisplayedRowAtIndex(0)?.data[WATCHLIST_GRID_INDEX.SEGMENT_ID], WATCHLIST_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0)?.data[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
          dispatch(getFocusedCard(WATCHLIST_GRID_REF?.current?.api.getDisplayedRowAtIndex(0)?.data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
        }
      }
    }
  }, []);

  useEffect(() => {
    setChartData([]);
    sendTouchlineRequest([{ exchangeId: tempScripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: tempScripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true }]);
    if (timeInterval === '1D') {
      let temp = [];
      marketMovementInfo?.forEach((x, i) => {
        if (i !== 0 && marketMovementInfo[i - 1]?.Time === x?.Time) { return; }
        let epochTime = moment(x.Time, 'HH:mm:ss').add(5, 'hours').add(30, 'minutes').unix();
        temp.push({
          time: epochTime,
          open: x.nOpen,
          close: x.nClose,
          high: x.nHigh,
          low: x.nLow,
          value: x?.nClose,
          volume: x?.nTotalQtyTraded
        });
      });
      setChartData(temp);
      if (!chartURL && temp?.length === 0) {
        setZeroStateShow(true);
      } else {
        setZeroStateShow(false);
      }
    } else {
      setChartData(lineData);
    }
  }, [chartURL, timeInterval, lineData, marketMovementInfo]);

  useEffect(() => {
    if ((!chartURL || chartURL === '') && !apiCalled && lineData?.length === 0) {
      handleApi(timeInterval);
      setApiCalled(true);
    }
  }, [apiCalled, chartURL, handleApi, lineData, timeInterval, chartTab, tempScripOrderInfo]);

  useEffect(() => {
    setLineData([]);
    setApiCalled(false);
  }, [tempScripOrderInfo]);

  /* Deepti B. BT-107426 calling get chart data API on click of chart icon */
  useEffect(() => {
    if ((!chartURL || chartURL === '')) {
      if (timeInterval === '1D') {
        if (tempScripOrderInfo?.length !== 0) {
          const objMarketMovementPaylod = {
            MktSegId: tempScripOrderInfo?.[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
            Token: tempScripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
            TimeInterval: 1
          };
          const decimalLocator = tempScripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
          const decimalLocatorLength = tempScripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];
          dispatch(getMarketMovementInfo(objMarketMovementPaylod, decimalLocator, decimalLocatorLength));
          dispatch(getSecurityDetails({ mktSegmentId: tempScripOrderInfo?.[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID], token: tempScripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN] }));
        } else { }
      }
    }
  }, [timeInterval, chartURL, dispatch, tempScripOrderInfo]);

  useEffect(() => {
    let interval = setInterval(() => {
      if ((!chartUrl || chartUrl === '')) {
        if (timeInterval === '1D') {
          if (tempScripOrderInfo?.length !== 0) {
            const decimalLocator = tempScripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
            const decimalLocatorLength = tempScripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];
            let objMarketMovementPaylod = {
              MktSegId: tempScripOrderInfo[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
              Token: tempScripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN],
              TimeInterval: 1
            };
            dispatch(getMarketMovementFailure([]));
            dispatch(getMarketMovementInfo(objMarketMovementPaylod, decimalLocator, decimalLocatorLength));
            objMarketMovementPaylod = {};
          } else { }
        }
      }
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, [timeInterval, chartUrl, dispatch, tempScripOrderInfo,chartExpand]);

  useEffect(() => {
    if (syncWatchlist) {
      setApiCalled(false);
      setLineData([]);
      setTempScripOrderInfo(selectedRow);
    }
  }, [selectedRow, syncWatchlist]);

  useEffect(() => {
    dispatch(getScripOrderInfo({ isBuySell: objScripOrderInfo.isBuySell, activeExchangeId: selectedRow[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: selectedRow }));
    setTempScripOrderInfo(selectedRow);
  }, [selectedRow]);

  useWFHMessages('touchline', (e) => {
    if (tempScripOrderInfo?.length) { // Parshva S: 20/12/24 : live chart fixes
      if (e.detail[TL_INDEX.TOKEN] === tempScripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN]) {
        sendDataToChart(e.detail, tempScripOrderInfo);
      }
    }
  });

  // Deepti b. BT-107398 [18/11/2024]: setting selected heatmap tile data for the scrip card
  useEffect(() => {
    if (syncWatchlist) {
      if (watchlistView?.[0] === GRID_VIEW.HEAT_MAP) {
        setchartURL(createChartUrl(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID], selectedHeatmapTile[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
        setSelectedRow(selectedHeatmapTile);
        dispatch(getFocusedCard(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));

      } else if (watchlistView?.[0] === GRID_VIEW.DEFAULT_VIEW) {
        if (scripOrderInfo?.length) {
          setchartURL(createChartUrl(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
          setSelectedRow(scripOrderInfo);
          dispatch(getFocusedCard(scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
        }
      }
    }
  }, [chartAttributes, dispatch, scripOrderInfo, syncWatchlist, selectedHeatmapTile]);
  //Vaibhav Singh : BT-117493 : 13-09-2023 : Removed Global Search and header

  // Deepti b. BT-107398 [18/11/2024]: setting selected heatmap tile data for the scrip card
  useEffect(() => {
    if (scripOnExpand?.length && syncWatchlist) {
      if (watchlistView?.[0] === GRID_VIEW.HEAT_MAP) {
        setchartURL(createChartUrl(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID], selectedHeatmapTile[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
        setSelectedRow(selectedHeatmapTile);
        dispatch(getFocusedCard(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
      } else if (watchlistView?.[0] === GRID_VIEW.DEFAULT_VIEW) {
        setchartURL(createChartUrl(scripOnExpand[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOnExpand[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
        setSelectedRow(scripOnExpand);
        dispatch(getFocusedCard(scripOnExpand[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
      }
    }
  }, [scripOnExpand]);
  //Vaibhav Singh: 18-08-24: Changes Updated when data is not on focus: Start
  useEffect(() => {
    if (syncWatchlist) {
      const lastRowNodeInd = WATCHLIST_GRID_REF?.current?.api?.getFocusedCell()?.rowIndex;
      WATCHLIST_GRID_REF?.current?.api?.setFocusedCell(lastRowNodeInd ? lastRowNodeInd : 0, WATCHLIST_GRID_REF?.current?.columnApi?.getAllDisplayedColumns()[0]);
    }
  }, [syncWatchlist]);
  //Vaibhav Singh : BT-117493 : 13-09-2023 : handled sync watchlist selcted row to show issue added toast msg
  const handleToast = () => {
    setSyncWatchlist(false);
    setSelectedRow(savePrevData.prevRow?.length ? savePrevData.prevRow : selectedRow);
    setchartURL(savePrevData.prevChart ? savePrevData.prevChart : chartURL);
    dispatch(getFocusedCard(selectedRow[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
  };
  const handleSync = () => {
    setSyncWatchlist(prevState => {
      return !prevState;
    });
    if (!syncWatchlist) {
      if (watchlistView?.[0] === GRID_VIEW.DEFAULT_VIEW) {
        if (WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0]?.length) {
          setSavePrevData({ prevChart: chartURL, prevRow: selectedRow });
          setSelectedRow(WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0]);
          setchartURL(createChartUrl(WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], WATCHLIST_GRID_REF?.current?.api?.getSelectedRows()[0][WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
          dispatch(getFocusedCard(WATCHLIST_GRID_REF.current?.api?.getSelectedRows()[0][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
        }
        else {
          if (scripOnExpand?.length) {
            setSavePrevData({ prevChart: chartURL, prevRow: selectedRow });
            setchartURL(createChartUrl(scripOnExpand[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripOnExpand[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
            setSelectedRow(scripOnExpand);
            dispatch(getFocusedCard(scripOnExpand[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));
          }
        }
        // Deepti b. BT-107398 [18/11/2024]: setting selected heatmap tile data for the scrip card in case of heatmap view
      } else if (watchlistView?.[0] === GRID_VIEW.HEAT_MAP) {
        setSavePrevData({ prevChart: chartURL, prevRow: selectedHeatmapTile });
        setSelectedRow(selectedHeatmapTile);
        setchartURL(createChartUrl(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID], selectedHeatmapTile[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes));
        setSelectedRow(selectedHeatmapTile);
        dispatch(getFocusedCard(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]));

      }
      dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: 'Chart is synchronized with Watchlist', button: [{ btnName: "UNDO", onClickHandler: handleToast, className: "btn btn-outline-active ms-3" }] }));
    } else {
      setSavePrevData({ prevChart: chartURL, prevRow: selectedRow });
    }


  };
  const handleOverview = (e) => {
    dispatch(setScripOverviewData(selectedRow));
    // setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
    // setToggleSideContainer(false);
    // setActiveMenu({});
    dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
  };
  const handleRedirectOnChart = () => {
    // window.open(chartURL, '_blank');
    setEncryptLocalStorage("OVERVIEW_CHART_DATA", JSON.stringify({ chartUrl: createChartUrl(tempScripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], tempScripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes), data: scripOrderInfo }));
    setTimeout(() => {
      window.open(LOCATIONS.CHART);
    }, 300);
  };
  //Vaibhav Singh: 18-03-23: Added new call up function:start
  const handleChangeChart = (each, chartAttributes) => {
    // Deepti b. BT-107398 [18/11/2024]: setting selected heatmap tile data for the scrip card in case of heatmap view
    if (watchlistView?.[0] === GRID_VIEW.HEAT_MAP) {
      setToggledURL(each?.name);
      setchartURL(createChartUrl(selectedHeatmapTile[WATCHLIST_GRID_INDEX.SEGMENT_ID], selectedHeatmapTile[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes, "", each));
    } else {
      setToggledURL(each?.name);
      setchartURL(createChartUrl(selectedRow[WATCHLIST_GRID_INDEX.SEGMENT_ID], selectedRow[WATCHLIST_GRID_INDEX.TOKEN], chartAttributes, "", each));
    }
  };
  const handleExpandAndCollapse = useCallback(() => {

    setChartExpand(prevState => {
      dispatch(updateSideExapnsion(!prevState));
      return !prevState;
    });
  }, [dispatch]);
  return (
    <>

      <div className='stickysidemenu-header'>
        <Container fluid className='p-0 trading-view-btn'>
          <Row className='g-0 py-2 px-3'>
            <Col md='auto' className='d-flex justify-content-start align-items-center'>
              {/* {(chartAttributes?.nMultiChartPresent) ?
                <div className='screen-dropdown me-2'>
                  <BzDropdown>
                    <Dropdown.Toggle className='d-flex align-items-center'>
                      <span className='icon-trading-view icon-20 me-1'></span>
                      <span className='font-medium font-size1 line-height-1'>{toggledURL}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {chartAttributes?.nChartUrl?.map((each) => {
                        return <Dropdown.Item onClick={(e) => { handleChangeChart(each, chartAttributes); }}>{each?.name.length > 10 ? `${each?.name}...` : each?.name}</Dropdown.Item>;
                      })}
                    </Dropdown.Menu>
                  </BzDropdown>
                </div>
                : null}

              {chartAttributes?.nChartUrl === "" || chartAttributes?.nChartUrl === undefined ?
                <SideChartScripInfo bToggleSearchBar={bToggleSearchBar} selectedRow={selectedRow} setSelectedRow={setSelectedRow} setBToggleSearchBar={setBToggleSearchBar} />
                : null} */}

            </Col>

            <Col md='auto' className='d-flex justify-content-end align-items-center ms-auto'>
              <BzButton className='btn btn-positive btn-sm text-capitalize ms-2' onClick={onBuySellClick.bind(this, 'BUY')}>B</BzButton>
              <BzButton className='btn btn-negative btn-sm text-capitalize ms-2' onClick={onBuySellClick.bind(this, 'SELL')}>S</BzButton>
              {isVertical ? <BzToolTip placement={'bottom'} TooltipMsg={'This option will synchronize below chart with the watchlist on the left. You can click on the scrip name on the left or click down arrow on your keyboard to change the chart accordingly'}>
                <div className={`btn btn-outline ${syncWatchlist ? "btn-positive" : ''} btn-rounded btn-sm d-flex align-items-center ms-2`} onClick={handleSync}>
                  {<div className={`icon-16 ${syncWatchlist ? 'icon-sync' : 'icon-nosync'}  icon-primary me-2`}></div>}
                  <span>Sync Watchlist</span>
                </div>
              </BzToolTip> : null}
              {(chartAttributes?.nChartUrl === "" || chartAttributes?.nChartUrl === undefined) ? null :
                <BzToolTip placement={'top'} TooltipMsg={'Open in new tab'}>
                  <div className='icon-16 icon-expand-fullview icon-dark ms-3' onClick={handleRedirectOnChart}></div>
                </BzToolTip>
              }
              {isVertical ?
                <>
                  <BzToolTip placement={'bottom'} TooltipMsg={isExpanded?.isTrue ? 'Collapse' : 'Expand'}>
                    <div onClick={() => setIsExpanded(prevState => { return { ...prevState, isTrue: !prevState?.isTrue, containerLength: prevState?.isTrue ? SIDE_TRAY_EXPAND_PERCENTAGE?.FIFTY_PERCENT : SIDE_TRAY_EXPAND_PERCENTAGE?.SEVENTY_FIVE_PERCENT }; })} className={`icon-16 icon-dark ${isExpanded?.isTrue ? "icon-collapse" : "icon-expand"} ms-3`}></div>
                  </BzToolTip>
                  <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                    <div className='icon-16 icon-dark icon-close ms-3' onClick={() => { setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); setToggleSideContainer(false); setActiveMenu({}); }}></div>
                  </BzToolTip>
                </>
                :
                <>
                  <BzToolTip placement={'bottom'} TooltipMsg={chartExpand ? 'Collapse' : 'Expand'}>
                    <div onClick={() => handleExpandAndCollapse()} className={`icon-16 icon-dark ${chartExpand ? "icon-collapse" : "icon-expand me-6"} ms-3`}></div>
                  </BzToolTip>
                  {chartExpand ?
                    <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                      <div className='icon-16 icon-dark icon-close ms-3' onClick={() => { setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); setToggleSideContainer(false); setActiveMenu({}); }}></div>
                    </BzToolTip>
                    : null}
                </>
              }
            </Col>

          </Row>
        </Container>
      </div>

      <div className='stickysidemenu-content'>
        <Container fluid className='p-0'>
          <Row className='g-0'>
            <Col className='d-flex justify-content-start align-items-center'>
              {chartAttributes?.nChartUrl ? null :
                <>
                  <Container fluid className='p-0'>
                    <Row className='g-0 bdr-top bdr-btm py-2'>
                      <Col className='d-flex justify-content-start align-items-center'>
                        <div className='me-3 ps-3 bdr-lft'>
                          <Dropdown className='d-flex align-items-center'>
                            <Dropdown.Toggle as={CustomDropdownToggle} className={`d-flex align-items-center`}>
                              <div className='font-medium font-size1 color-text pe-2'>{timeInterval} ({timeInterval === '1D' ? '1 Min' : 'Daily'})</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {Object.keys(mappedTime)?.map((each) => {
                                return <Dropdown.Item onClick={(e) => { handleApi(each); setTimeInterval(each); }}>{each} ({each === '1D' ? '1 Min' : 'Daily'})</Dropdown.Item>;
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        {/* } */}
                        <div className='me-3 ps-3 bdr-lft'>
                          <Dropdown className='d-flex align-items-center'>
                            <Dropdown.Toggle as={CustomDropdownToggle} className='d-flex align-items-center'>
                              <div className='icon-16 icon-function icon-dark me-1'></div>
                              <div className='font-medium font-size1 color-text pe-2'>SMA {maType}</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={(e) => { setMaType(20); }}>SMA 20</Dropdown.Item>
                              <Dropdown.Item onClick={(e) => { setMaType(50); }}>SMA 50</Dropdown.Item>
                              <Dropdown.Item onClick={(e) => { setMaType(100); }}>SMA 100</Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className='me-3 ps-3 bdr-lft'>
                          <Dropdown className='d-flex align-items-center'>
                            <Dropdown.Toggle as={CustomDropdownToggle} className='d-flex align-items-center'>
                              <div className={`icon-16 icon-${chartType.toLowerCase()} icon-dark me-1`}></div>
                              <div className='font-medium font-size1 color-text pe-2'>{chartType}</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={(e) => { setChartType('Candles'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-candles icon-dark me-2'></div>
                                  <div className='p-t-3'>Candles</div>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={(e) => { setChartType('Line'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-line icon-dark me-2'></div>
                                  <div className='p-t-3'>Line</div>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={(e) => { setChartType('Bars'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-bars icon-dark me-2'></div>
                                  <div className='p-t-3'>Bars</div>
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item onClick={(e) => { setChartType('Area'); }}>
                                <div className='d-flex justify-content-start align-items-center'>
                                  <div className='icon-16 icon-area icon-dark me-2'></div>
                                  <div className='p-t-3'>Area</div>
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </>
              }
            </Col>
          </Row>
          {!zeroStateShow ?
            chartURL ? <ChartWidget halfHeight={halfHeight} chartUrl={chartURL} /> : chartType == 'Candles' ? <CandleChart halfHeight={halfHeight} mode={CHART_OPEN_MODE.SIDETRAY} lineData={chartData} isMa={maType} isExpand={isExpanded?.isTrue} /> : chartType == 'Line' ? <LineChart halfHeight={halfHeight} mode={CHART_OPEN_MODE.SIDETRAY} lineData={chartData} isMa={maType} isExpand={isExpanded?.isTrue} /> : chartType == 'Bars' ? <BarChart halfHeight={halfHeight} mode={CHART_OPEN_MODE.SIDETRAY} lineData={chartData} isMa={maType} isExpand={isExpanded?.isTrue} /> : <AreaChart halfHeight={halfHeight} mode={CHART_OPEN_MODE.SIDETRAY} lineData={chartData} isMa={maType} isExpand={isExpanded?.isTrue} />
            :
            <Row className='g-0'>
              <Col md={6} className='mrgauto'>
                <div className='zero-state-alerts zero-state-alerts-lg'>
                  <ZeroStates subText="" isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                  <div className='font-regular font-size2 color-nodata'>Something went wrong.</div>
                  <div className='font-regular font-size2 color-nodata'>Let us fix the problem and get back to you soon. Meanwhile try</div>
                  <div className='font-regular font-size2 color-nodata'><span className='color-primary'>Refreshing the page</span> or come back later.</div>
                </div>
              </Col>
            </Row>}
        </Container>
      </div>

    </>
  );
};

export default memo(SideChart);
